import ProductionPlan from "./ProductionPlan";

const PlannerDashboard = () => {
  return <ProductionPlan />;
};

export default PlannerDashboard;